import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import InformationToolTip from '../../../components/elements/information-tooltip'
import { EnrollmentDocumentStatus, getEnrollmentDocumentStatusColorAndVariant } from '../utils'

type Props = {
  enrollmentDocumentStatus: EnrollmentDocumentStatus
}

const EnrollmentDocumentStatusTooltip = ({ enrollmentDocumentStatus }: Props) => {
  const { color, variant } = getEnrollmentDocumentStatusColorAndVariant(
    enrollmentDocumentStatus.status
  )
  return (
    <InformationToolTip
      icon={
        <Badge
          variant={variant}
          size="small"
          icon={<enrollmentDocumentStatus.icon width="25px" height="25px" color={color} />}
        />
      }
    >
      <Typography variant={'label-medium'} color={tailwindColors.white.DEFAULT}>
        {enrollmentDocumentStatus.label}
      </Typography>
    </InformationToolTip>
  )
}

export default EnrollmentDocumentStatusTooltip
